module.exports = __webpack_public_path__ + "assets/images/project/constituencies/bishan-toa-payoh-grc.jpg?v=a2bfbcda";